/* Shared progressive enhancement: photos and original links remain usable without JavaScript. */
(() => {
  function enhance(root = document) {
    root.querySelectorAll('[data-reference-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      const photos = [...gallery.querySelectorAll('.pvbr-photo')];
      if (!photos.length) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-photo-index]')];
      let active = 0;
      let dialog;
      let opener;
      function choose(index) {
        active = (index + photos.length) % photos.length;
        photos.forEach((photo, i) => { photo.hidden = i !== active; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
        const status = gallery.querySelector('[data-photo-status]');
        if (status) status.textContent = `Foto ${active + 1} von ${photos.length}`;
        if (dialog?.open) updateDialog();
      }
      function updateDialog() {
        const source = photos[active].querySelector('img');
        const image = dialog.querySelector('img');
        image.src = source.src;
        image.alt = source.alt;
        dialog.querySelector('[data-dialog-counter]').textContent = `Foto ${active + 1} von ${photos.length}`;
        dialog.querySelector('[data-dialog-caption]').textContent = photos[active].querySelector('figcaption').textContent;
      }
      function addSwipe(element) {
        let start;
        element.addEventListener('touchstart', event => {
          start = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
        }, {passive:true});
        element.addEventListener('touchend', event => {
          if (!start || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          start = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) choose(active + (dx < 0 ? 1 : -1));
        }, {passive:true});
      }
      function makeDialog() {
        dialog = document.createElement('dialog');
        dialog.className = 'pvbr-lightbox color-background-1';
        dialog.setAttribute('aria-label', 'Projektfoto vergrößert');
        dialog.innerHTML = '<div class="pvbr-lightbox-top"><span data-dialog-counter></span><button type="button" data-dialog-close>Schließen</button></div><img alt=""><p data-dialog-caption></p><div class="pvbr-lightbox-controls"><button type="button" data-dialog-prev>← Zurück</button><button type="button" data-dialog-next>Weiter →</button></div>';
        document.body.appendChild(dialog);
        dialog.querySelector('[data-dialog-close]').onclick = () => dialog.close();
        dialog.querySelector('[data-dialog-prev]').onclick = () => choose(active - 1);
        dialog.querySelector('[data-dialog-next]').onclick = () => choose(active + 1);
        dialog.querySelector('.pvbr-lightbox-controls').hidden = photos.length < 2;
        dialog.addEventListener('close', () => (photos[active].querySelector('[data-photo-open]') || opener)?.focus({preventScroll:true}));
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); choose(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        dialog.addEventListener('click', event => {
          const r = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
        });
        addSwipe(dialog.querySelector('img'));
      }
      photos.forEach((photo, index) => photo.querySelector('[data-photo-open]').addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof HTMLDialogElement === 'undefined') return;
        event.preventDefault();
        opener = event.currentTarget;
        choose(index);
        if (!dialog) makeDialog();
        dialog.showModal(); updateDialog();
      }));
      thumbs.forEach(thumb => thumb.addEventListener('click', () => choose(Number(thumb.dataset.photoIndex))));
      const controls = gallery.querySelector('.pvbr-thumbnails');
      if (controls) controls.hidden = false;
      addSwipe(gallery.querySelector('.pvbr-photos'));
      choose(0);
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
